import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import SpeechRecognition, {
  useSpeechRecognition,
} from 'react-speech-recognition'

import { InterviewButtonsContainer } from '../styled'
import PrimaryButton from '../buttons/PrimaryButton'
import Mic from '../../assets/svgs/mic'
import StopCircle from '../../assets/svgs/stopCircle'

export default function SpeechToText({
  setTranscribedText,
  transcribedText,
  onResetTranscript,
  isRecorderDisabled,
  isLoading,
  method,
  questionStatus,
  setQuestionStatus,
}) {
  const { t } = useTranslation()
  const {
    transcript,
    finalTranscript,
    interimTranscript,
    listening,
    resetTranscript,
  } = useSpeechRecognition()

  const startRecordController = () => {
    SpeechRecognition.startListening({ continuous: true })
  }

  const handleStartRecording = () => {
    setQuestionStatus('recording')
    startRecordController()
  }

  const handleStopRecording = () => {
    SpeechRecognition.stopListening()
    setQuestionStatus('stopped')
  }

  useEffect(() => {
    const currentTranscript =
      transcribedText !== ''
        ? `${finalTranscript}${interimTranscript}`
        : `${finalTranscript}${interimTranscript}`
    setTranscribedText(currentTranscript)
    method.setValue('answer', currentTranscript)
  }, [
    transcript,
    setTranscribedText,
    transcribedText,
    finalTranscript,
    interimTranscript,
    method,
  ])

  useEffect(() => {
    onResetTranscript(resetTranscript)
  }, [resetTranscript])

  return (
    <InterviewButtonsContainer>
      {((questionStatus === 'notAnswered' && !listening) ||
        (questionStatus === 'stopped' && !listening)) && (
        <PrimaryButton
          onClick={handleStartRecording}
          disabled={isRecorderDisabled || isLoading}
        >
          <Mic
            width={18}
            height={18}
            color="#FFFFFF"
            style={{ marginRight: '5px' }}
          />
          {t('interview.startListening')}
        </PrimaryButton>
      )}
      {questionStatus === 'recording' && listening && (
        <PrimaryButton
          backgroundcolor="#A93C38"
          hovercolor="#8B302E"
          onClick={handleStopRecording}
          disabled={isRecorderDisabled || isLoading}
        >
          <StopCircle style={{ marginRight: '5px' }} />
          {t('interview.stopListening')}
        </PrimaryButton>
      )}
    </InterviewButtonsContainer>
  )
}

SpeechToText.propTypes = {
  setTranscribedText: PropTypes.func.isRequired,
  transcribedText: PropTypes.string.isRequired,
  onResetTranscript: PropTypes.func.isRequired,
  isRecorderDisabled: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  method: PropTypes.shape({
    mode: PropTypes.string.isRequired,
    setValue: PropTypes.func.isRequired,
    resolver: PropTypes.func.isRequired,
    defaultValues: PropTypes.shape({
      answer: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  questionStatus: PropTypes.string.isRequired,
  setQuestionStatus: PropTypes.func.isRequired,
}
